module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j8TJu"))).then(() => parcelRequire('hEqeo'));